import moment from "moment";

export const isoStringToMonthYear = (isoString: string) => {
  if (moment(isoString, true).isValid())
    return `${moment(isoString).format("MMM")} ${moment(isoString).year()}`;
  else return null;
};
